// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"sW-z","sponsoredTooltipWrapper":"tW-z","sponsoredTooltip":"uW-z","newCard":"vW-z"};